import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';

import type { User } from '@kernel';

import { AuthStore } from '@core/auth';
import { I18nPipe } from '@core/i18n';

import { AvatarComponent } from '@shared/avatar';
import { ButtonComponent, IconButtonComponent } from '@shared/button';
import { InitialsPipe } from '@shared/initials';
import {
  MenuDirective,
  MenuDividerDirective,
  MenuItemDirective,
  MenuTriggerDirective,
} from '@shared/menu';
import { TooltipDirective } from '@shared/tooltip';

import { PROFILE_ACTION_GROUPS, type ProfileActionId, TOPBAR_ACTIONS } from './topbar.types';

@Component({
  selector: 'ks-topbar',
  imports: [
    NgOptimizedImage,
    I18nPipe,
    AvatarComponent,
    ButtonComponent,
    IconButtonComponent,
    InitialsPipe,
    TooltipDirective,
    MenuTriggerDirective,
    MenuDirective,
    MenuItemDirective,
    MenuDividerDirective,
  ],
  templateUrl: './topbar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopbarComponent {
  readonly user = input.required<User | null>();

  private readonly authStore = inject(AuthStore);

  protected readonly topbarActions = TOPBAR_ACTIONS;
  protected readonly profileActionGroups = PROFILE_ACTION_GROUPS;

  protected onAction(actionId: ProfileActionId): void {
    if (actionId === 'signOut') this.authStore.logout();
  }
}
